import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SlideMenu({ open, onClose }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  function go(path) {
    onClose();
    navigate(path);
  }

  function handleLogout() {
    onClose();
    logout();
  }

  const MENU_ITEMS = [
    {
      label: 'Settings',
      path:  '/settings',
      icon:  () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
        </svg>
      )
    },
    {
      label: 'Bank Connections',
      path:  '/banks',
      icon:  () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      )
    },
    {
      label: 'Cash Out',
      path:  '/cashout',
      icon:  () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <rect x="1" y="4" width="22" height="16" rx="2"/>
          <line x1="1" y1="10" x2="23" y2="10"/>
        </svg>
      )
    },
    {
      label: 'Tax Summary',
      path:  '/tax',
      icon:  () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10 9 9 9 8 9"/>
        </svg>
      )
    },
    {
      label: 'Transactions',
      path:  '/transactions',
      icon:  () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
      )
    },
    {
      label: 'Payment Links',
      path:  '/recurring',
      icon:  () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <polyline points="17 1 21 5 17 9"/>
          <path d="M3 11V9a4 4 0 014-4h14"/>
          <polyline points="7 23 3 19 7 15"/>
          <path d="M21 13v2a4 4 0 01-4 4H3"/>
        </svg>
      )
    },
    {
      label: 'Integrations',
      path:  '/integrations',
      icon:  () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <rect x="2" y="3" width="6" height="6" rx="1"/>
          <rect x="16" y="3" width="6" height="6" rx="1"/>
          <rect x="2" y="15" width="6" height="6" rx="1"/>
          <rect x="16" y="15" width="6" height="6" rx="1"/>
          <path d="M8 6h8M5 9v6M19 9v6M8 18h8"/>
        </svg>
      )
    },
  ];

  return (
    <>
      {open && <div style={s.overlay} onClick={onClose}/>}

      <div style={{...s.panel, transform: open ? 'translateX(0)' : 'translateX(100%)'}}>

        <div style={s.header}>
          <div style={s.profileWrap}>
            <div style={s.avatar}>
              {user?.name?.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2)}
            </div>
            <div>
              <div style={s.name}>{user?.name}</div>
              <div style={s.email}>{user?.email || user?.phone}</div>
            </div>
          </div>
          <button style={s.closeBtn} onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <div style={s.menuList}>
          {MENU_ITEMS.map((item, i) => (
            <button key={item.path} style={{
              ...s.menuItem,
              borderBottom: i < MENU_ITEMS.length - 1 ? '1px solid #F5F5F7' : 'none'
            }} onClick={() => go(item.path)}>
              <div style={s.menuIconWrap}>
                <item.icon/>
              </div>
              <span style={s.menuLabel}>{item.label}</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#AEAEB2" strokeWidth="2">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </button>
          ))}
        </div>

        <div style={s.footer}>
          <button style={s.logoutBtn} onClick={handleLogout}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF3B30" strokeWidth="1.8">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/>
            </svg>
            Log out
          </button>
          <button style={s.termsLink} onClick={() => go('/terms')}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
            </svg>
            Terms of Service
          </button>
        </div>

      </div>
    </>
  );
}

const s = {
  overlay:     {position:'fixed', inset:0, background:'rgba(0,0,0,0.25)', zIndex:200, backdropFilter:'blur(2px)'},
  panel:       {position:'fixed', top:0, right:0, bottom:0, width:'78%', maxWidth:300, background:'#fff', zIndex:201, transition:'transform 0.3s cubic-bezier(0.4,0,0.2,1)', display:'flex', flexDirection:'column', boxShadow:'-8px 0 40px rgba(0,0,0,0.10)'},
  header:      {display:'flex', justifyContent:'space-between', alignItems:'center', padding:'56px 20px 20px', borderBottom:'1px solid #F5F5F7'},
  profileWrap: {display:'flex', alignItems:'center', gap:12},
  avatar:      {width:40, height:40, borderRadius:'50%', background:'#007AFF', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:600, flexShrink:0},
  name:        {fontSize:15, fontWeight:600, color:'#1D1D1F'},
  email:       {fontSize:12, color:'#6E6E73', marginTop:2},
  closeBtn:    {width:30, height:30, borderRadius:8, background:'#F5F5F7', border:'none', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer'},
  menuList:    {flex:1, padding:'8px 0', overflowY:'auto'},
  menuItem:    {display:'flex', alignItems:'center', gap:14, width:'100%', padding:'14px 20px', background:'none', border:'none', cursor:'pointer'},
  menuIconWrap:{width:32, height:32, borderRadius:8, background:'#F5F5F7', display:'flex', alignItems:'center', justifyContent:'center', color:'#1D1D1F', flexShrink:0},
  menuLabel:   {flex:1, fontSize:15, fontWeight:500, color:'#1D1D1F', textAlign:'left'},
  footer:      {padding:'16px 20px 32px', borderTop:'1px solid #F5F5F7'},
  logoutBtn:   {display:'flex', alignItems:'center', gap:10, width:'100%', padding:'12px 16px', background:'#FFF0EF', border:'none', borderRadius:12, fontSize:15, fontWeight:500, color:'#FF3B30', cursor:'pointer', marginBottom:8},
  termsLink:   {display:'flex', alignItems:'center', justifyContent:'center', gap:6, width:'100%', padding:'4px 0', background:'none', border:'none', fontSize:11, color:'#AEAEB2', cursor:'pointer'},
};
